// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2yjTC","footer":"Form_footer__3qkIj"};